import React from 'react';
import TagView from './tag';
import useTagPage from '../../../hooks/useTagPage';
import AskQuestionButton from '../askQuestionButton';
import BreadcrumbNav, { BreadcrumbItemProps } from '../../common/BreadcrumbNav';

/**
 * Represents the TagPage component which displays a list of tags
 * and provides functionality to handle tag clicks and ask a new question.
 */
const TagPage = () => {
  const { tlist, clickTag } = useTagPage();

  // Define breadcrumb items
  const breadcrumbItems: BreadcrumbItemProps[] = [
    { label: 'Home', href: '/home' },
    { label: 'Tags' },
  ];

  return (
    <div className='container py-8'>
      {/* Breadcrumb Navigation */}
      <BreadcrumbNav items={breadcrumbItems} />

      <div className='flex justify-between items-center py-4 px-6 border-b border-gray-200 mb-4'>
        <div className='font-bold text-lg'>{tlist.length} Tags</div>
        <div className='font-bold text-lg'>All Tags</div>
        <AskQuestionButton />
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 px-6'>
        {tlist.map(t => (
          <TagView key={t.name} t={t} clickTag={clickTag} />
        ))}
      </div>
    </div>
  );
};

export default TagPage;
